<div class="grid-container">
  <div class="grid-item">
    <label class='spo-detail-margin-between'>Partner</label>
    <div class="spo-detail" id="partner">
      <span data-cy="spo-detail-partner">{{$safeNavigationMigration(spoDetail?.partner) | prettyPrintReference | undefinedValue}}</span>
    </div>
  </div>

  <div class="grid-item">
    <label class='spo-detail-margin-between'>Ship to party</label>
    <div class="spo-detail" id="shipToParty">
      <span data-cy="spo-detail-shipToParty">{{$safeNavigationMigration(spoDetail?.shipToParty) | prettyPrintReference | undefinedValue}}</span>
    </div>
  </div>

  <div class="grid-item">
    <label class='spo-detail-margin-between'>Supplying packing plant</label>
    <div class="spo-detail" id="supplyingPackingPlant">
      @if (!spoDetail?.supplyingPackingPlant) {
        <app-warning-inline
          [warningInlineLabel]="requiredForSendLabel"
        [warningType]="WarningInlineEnum.WARNING_SEND"></app-warning-inline>
      }
      @if (spoDetail?.supplyingPackingPlant) {
        <span
        data-cy="spo-detail-supplyingPlant">{{$safeNavigationMigration(spoDetail?.supplyingPackingPlant) | prettyPrintReference | undefinedValue}}</span>
      }
    </div>
  </div>

  <div class="grid-item">
    <label class='spo-detail-margin-between'>Reason</label>
    <div class="spo-detail" id="reason">
      @if (!spoDetail?.reason) {
        <app-warning-inline
          [warningInlineLabel]="requiredForSendLabel"
        [warningType]="WarningInlineEnum.WARNING_SEND"></app-warning-inline>
      }
      @if (spoDetail?.reason) {
        <span
        data-cy="spo-detail-reason">{{$safeNavigationMigration(spoDetail?.reason) | prettyPrintReference | undefinedValue}}</span>
      }
    </div>
  </div>

  @if (spoDetail?.transportMode) {
    <div class="grid-item">
      <label class='spo-detail-margin-between'>Transport mode</label>
      <div class="spo-detail" id="transportMode">
        @if (!spoDetail?.transportMode) {
          <app-warning-inline
            [warningInlineLabel]="requiredForSendLabel"
          [warningType]="WarningInlineEnum.WARNING_SEND"></app-warning-inline>
        }
        @if (spoDetail?.transportMode) {
          <span
          data-cy="spo-detail-transportMode">{{$safeNavigationMigration(spoDetail?.transportMode) | prettyPrintReference | undefinedValue}}</span>
        }
      </div>
    </div>
  }

  @if (haveTransportServiceOrRequiresTransportService) {
    <div class="grid-item">
      <label class='spo-detail-margin-between'>Service</label>
      <div class="spo-detail" id="transportService">
        @if (!spoDetail?.transportService) {
          <app-warning-inline
            [warningInlineLabel]="requiredForSendLabel"
            [warningType]="WarningInlineEnum.WARNING_SEND"
          ></app-warning-inline>
        }
        @if (spoDetail?.transportService) {
          <span
          data-cy="spo-detail-transportService">{{$safeNavigationMigration(spoDetail?.transportService) | prettyPrintReference | undefinedValue}}</span>
        }
      </div>
    </div>
  }

  <div class="grid-item-justification">
    @if (spoDetail?.transportService?.requiresJustification) {
      <div>
        <label class='spo-detail-margin-between'>Justification</label>
        <div class="spo-detail" id="justification">
          @if (!spoDetail?.justification) {
            <app-warning-inline
              [warningInlineLabel]="requiredForSendLabel"
            [warningType]="WarningInlineEnum.WARNING_SEND"></app-warning-inline>
          }
          @if (spoDetail?.justification) {
            <span
            data-cy="spo-detail-justification">{{$safeNavigationMigration(spoDetail?.justification) | undefinedValue}}</span>
          }
        </div>
      </div>
    }
  </div>

  <div [ngClass]="spoDetail?.transportService?.requiresJustification ? 'grid-item-requested-date-with-justification' : 'grid-item-requested-date'"
    class="grid-item">
    <label class='spo-detail-margin-between'>Requested date</label>
    <div class="spo-detail" id="requestedDate">
      @if (!spoDetail?.requestedDate) {
        <app-warning-inline
          [warningInlineLabel]="requiredForSendLabel"
        [warningType]="WarningInlineEnum.WARNING_SEND"></app-warning-inline>
      }
      @if (spoDetail?.requestedDate) {
        <div
          data-cy="spo-detail-requestedDate">{{$safeNavigationMigration(spoDetail?.requestedDate) | utcAsLocal | date:'dd-MM-yyyy' | undefinedValue}}
        </div>
      }
    </div>
  </div>

  @if (spoDetail?.sentDate) {
    <div class="grid-item grid-item-sent-date">
      <label class='spo-detail-margin-between'>Sent date</label>
      <div class="spo-detail" id="sentDate">
        <span class="spo-detail-sent-date-text"
        data-cy="spo-detail-sent-date">{{$safeNavigationMigration(spoDetail?.sentDate) | date:'dd-MM-yyyy HH:mm:ss' | undefinedValue}}</span>
      </div>
    </div>
  }
  @if (spoDetail?.sentUsername) {
    <div class="grid-item grid-item-sent-date">
      <label class='spo-detail-margin-between'>Email</label>
      <div class="spo-detail">
        <span class="spo-detail-sent-date-text"
        data-cy="spo-detail-sent-email">{{$safeNavigationMigration(spoDetail?.sentUsername)  | prettyPrintUpdatedBy | undefinedValue}}</span>
      </div>
    </div>
  }
</div>
